import { useDeviceType } from '../../../responsive';
export const useSize = size => {
  const deviceType = useDeviceType();
  if (size) {
    return size;
  }
  return deviceType === 'desktop' ? 'S' : 'M';
};